<template>
	<div id="chart"></div>
</template>

<script>
	import c3 from 'c3'
	import moment from 'moment'

	module.exports = {
		props:['values'],
		methods : {
			loadChart: function () {

				if(!this.values.weeks){
					return;
				}

				var xAxis = [];
				var cols = [];

				console.log('vasd');
				console.log(this.values.weeks);
				xAxis.push('x');

				for(let week of this.values.weeks){
					xAxis.push(week);
				}
				cols.push(xAxis);

				for(let data of this.values.data){
					var values = data.values;
					values.unshift(data.name);
					cols.push(values);
				}

				console.log(xAxis);
				console.log(cols);

				var chart = c3.generate({
					bindto: '#chart',
					data: {
						x: 'x',
						columns: cols
					},
					size: {
						height: 200
					},
					axis : {
						x : {
							type : 'timeseries',
							tick: {
								format: function (x) { return moment(x).format('MMM DD'); }
							}
						},
						y: {
							tick: {
								format: function (d) {
									return (parseInt(d) == d) ? d : null;
								}
							}
						}
					}
				});
			}
		},
		watch: {
			'values': function (val, oldVal) {
				this.loadChart();
			}
		},
		mounted: function(){
			this.loadChart();
		}
	}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// LineChart.vue?0c89b390